import React, { useMemo } from 'react';
import type { DataTableRenderCellParams, DataTableRowEventHandler } from '@/components/custom/erp/data-table-v2';
import type { ButtonType } from '@/components/custom/erp/input-table-v2';
import { ErpInputTableV2 } from '@/components/custom/erp';
import { SelectedCellInfo } from '../hooks/useDetailRows';
import { getDetailTableColumns } from './columns';
import { FormMode } from '@/types/form';

interface DetailTabProps {
  formMode: FormMode;
  rows: { uuid?: string | null }[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: DataTableRowEventHandler<MuaHangRecord>;
  onCellClick?: (params: DataTableRenderCellParams<MuaHangRecord>) => void;
  onCellValueChange: (rowUuid: string, field: string, newValue: MuaHangRecord) => void;
}

const DETAIL_ACTION_ORDER: ButtonType[] = ['pin'];
const tableActions: Partial<Record<ButtonType, () => void>> = {
  pin: () => {}
};

export const DetailTab: React.FC<DetailTabProps> = ({
  formMode,
  rows,
  selectedRowUuid,
  selectedCell,
  onRowClick,
  onCellClick,
  onCellValueChange
}) => {
  const columns = useMemo(() => getDetailTableColumns(onCellValueChange), [onCellValueChange]);

  return (
    <ErpInputTableV2
      rows={rows}
      onRowClick={onRowClick}
      onCellClick={onCellClick}
      selectedRowId={selectedRowUuid || undefined}
      pasteTarget={selectedCell}
      columns={columns}
      getRowId={row => row?.uuid || ''}
      actionsDisabled={formMode === 'view'}
      actions={tableActions}
      actionOrder={DETAIL_ACTION_ORDER}
    />
  );
};

export default DetailTab;
